import React, { useEffect, useState } from 'react';
import { apiGet } from '../api';
import '../components/EnglishBlog.css';

export default function EnBlogPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(9);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    let ignore = false;
    (async () => {
      try {
        setLoading(true);
        const resp = await apiGet('/api/posts', { locale: 'en', page, pageSize });
        const arr = Array.isArray(resp?.items) ? resp.items : [];
        if (!ignore) {
          const mapped = arr.map((p) => ({
            id: p.id,
            slug: p.slug,
            title: p.title,
            excerpt: p.excerpt || '',
            date: p.date,
            category: p.category?.slug || 'post',
            image: p.imageUrl || undefined,
            type: p.isAd ? 'ad' : 'post',
            adText: p.adText || undefined,
            ctaText: p.ctaText || undefined,
          }));
          setItems(mapped.filter((m) => m.title && m.type === 'post'));
          setTotal(Number(resp?.total || 0));
        }
      } catch (_) {
        if (!ignore) {
          setItems([]);
          setTotal(0);
        }
      } finally {
        if (!ignore) setLoading(false);
      }
    })();
    return () => { ignore = true; };
  }, [page]);

  const totalPages = Math.max(1, Math.ceil(total / pageSize));

  return (
    <section id="english-blog-full" className="english-blog-section" style={{ paddingTop: '24vh' }}>
      <div className="container">
        <div className="english-blog-header">
          <h2 className="english-blog-title">All English Blog Posts</h2>
          <p className="english-blog-subtitle">Complete list of English articles</p>
        </div>

        {loading && <div style={{ marginBottom: 12 }}>Loading…</div>}

        <div className="english-blog-grid">
          {items.map((post) => (
            <article key={post.id} className={`english-blog-card`} onClick={() => { if (post.slug) window.location.hash = `#/blog/en/${encodeURIComponent(post.slug)}`; }} style={{ cursor: 'pointer' }}>
              <div className="english-blog-image">
                <img
                  src={post.image}
                  alt={post.title}
                  onError={(e) => { e.currentTarget.src = `https://via.placeholder.com/400x250/2d5016/ffffff?text=${encodeURIComponent(post.category)}`; }}
                />
                <div className={`english-blog-category`}>{post.category}</div>
              </div>
              <div className="english-blog-content">
                <div className="english-blog-meta">
                  <span className="english-blog-date">{post.date}</span>
                </div>
                <h3 className="english-blog-post-title">{post.title}</h3>
                <p className="english-blog-excerpt">{post.excerpt}</p>
              </div>
            </article>
          ))}
          {!loading && items.length === 0 && (
            <div style={{ gridColumn: '1 / -1', textAlign: 'center', color: '#666' }}>No posts</div>
          )}
        </div>

        <div className="english-blog-footer" style={{ justifyContent: 'space-between' }}>
          <button className="english-view-all-posts" onClick={() => { window.location.hash = '#'; }}>Back to Home</button>
          <div style={{ display: 'flex', gap: 8 }}>
            <button className="english-view-all-posts" disabled={page <= 1} onClick={() => setPage((p) => Math.max(1, p - 1))}>Previous</button>
            <span style={{ alignSelf: 'center' }}>{page} / {totalPages}</span>
            <button className="english-view-all-posts" disabled={page >= totalPages} onClick={() => setPage((p) => Math.min(totalPages, p + 1))}>Next</button>
          </div>
        </div>
      </div>
    </section>
  );
}
